export default __webpack_public_path__ + "static/media/01.8da1b99c.jpg";